import { Component, inject, Optional } from '@angular/core';
import { ProductListItemContext } from '@spartacus/storefront';
import { CommonModule } from '@angular/common';
import { AddToCartModule } from '@spartacus/cart/base/components/add-to-cart';

@Component({
  selector: 'custom-product-grid-item-actions',
  templateUrl: './product-grid-item-actions.component.html',
  styleUrl: './product-grid-item-actions.component.scss',
  imports: [CommonModule, AddToCartModule],
})
export class CustomProductGridItemActionComponent {
  @Optional() protected productContext = inject(ProductListItemContext);

  product$ = this.productContext.product$;
}
